import React from 'react';
import styled from 'styled-components';

type Item = {
  key: string;
  label: React.ReactNode;
  count?: number;
};

export const SegmentedContainer = styled.div`
  display: inline-flex;
  background: #e9ecef;
  border-radius: .5rem;
  padding: .25rem;
  gap: .25rem;
  width: 100%;
  justify-content: center;

  button {
    border: 0;
    background: transparent;
    padding: .25rem .5rem;
    border-radius: .375rem;
    font-size: .9rem;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
  }

  .active {
    background: #fff;
    box-shadow: 0 1px 1px rgba(0,0,0,.05);
  }

  .badge {
    margin-left: .35rem;
    background: #0d6efd;
    color: #fff;
    border-radius: 1rem;
    padding: 0 .4rem;
    font-size: .75rem;
    line-height: 1.2;
  }

  .badge.zero {
    background: #6c757d;
  }
`;

export default function SegmentedControl({ items, activeKey, onChange }: { items: Item[]; activeKey: string; onChange: (key: string) => void }) {
  return (
    <SegmentedContainer>
      {items.map((it) => (
        <button key={it.key} className={activeKey === it.key ? 'active' : ''} onClick={() => onChange(it.key)}>
          {it.label}
          {typeof it.count === 'number' && (
            <span className={`badge ${it.count === 0 ? 'zero' : ''}`}>{it.count}</span>
          )}
        </button>
      ))}
    </SegmentedContainer>
  );
}
